import { Helmet } from 'react-helmet-async';

const OG_IMAGE = 'https://static.prod-images.emergentagent.com/jobs/67f71efc-94b5-413e-9931-8964cdff6057/images/ff47547e3762cb75914b087f9ae8a93a21e8f92cfc1806a2b8ed6977402a16b0.png';

export default function PageSEO({ title, description, path = '/' }) {
  const fullTitle = title ? `${title} | EpiSplain` : 'EpiSplain | Public Health Data, Explained Simply';
  const desc = description || 'EpiSplain makes epidemiology accessible. Explore chronic disease maps, autoimmune disease data, vaccine coverage, interactive risk calculators, and evidence-based public health education.';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:url" content={`https://episplain.com${path}`} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={OG_IMAGE} />
      <link rel="canonical" href={`https://episplain.com${path}`} />
    </Helmet>
  );
}
